<template lang="pug">
div
  template(v-if="!showEditMode")
    .d-flex.align-center
      template(v-if="value")
        .d-flex.align-center
          .text-sm Delivery charge
          v-btn.ml-2(v-if="isEditable" small icon @click="removeAdjustment")
            v-icon(small) mdi-close
      template(v-else)
        .text-sm.font-semibold.underline.clickable(v-if="isEditable" @click="showEditMode = true") Add delivery charge
        .text-sm(v-else) Delivery charge
      v-spacer
      .text-sm.no-wrap(v-if="!hidePrice") {{ value | displayPrice }}
  template(v-else)
    v-row(no-gutters align="center")
      v-col
        .text-sm.flex-grow-1 Add delivery charge
      v-spacer
      v-col.d-flex.align-center(cols="5")
        v-text-field.text-sm.round-xl(v-model.number="deliveryCharge" autofocus placeholder="0.00" outlined dense type="number" :prefix="$currency.symbol" hide-details="auto" @blur="handleConfirm")
</template>

<script>
export default {
  props: {
    hidePrice: {
      type: Boolean
    },
    value: {
      type: Number,
      default: 0
    },
    parentData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      showEditMode: false,
      deliveryCharge: 0
    }
  },
  computed: {
    isEditable () {
      return this.parentData?.order_status !== 'archived' && this.parentData?.order_status !== 'completed' 
    }
  },
  methods: {
    removeAdjustment () {
      this.$emit('input', 0)
    },
    handleConfirm () {
      const value = Math.round(this.deliveryCharge * this.$currency.multiplier)
      this.$emit('input', value)
      this.deliveryCharge = value
      this.showEditMode = false
    }
  },
}
</script>

<style lang="scss" scoped>
</style>